module.exports = __webpack_public_path__ + "img/任继辉.769fa651.jpg";